// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.references_references_container__qXkI-{
    display: flex; 
    flex-direction: row;
    align-items: flex-start ; 
    flex: 1 1; 
    align-items: flex-start;
    align-content: flex-start;
    justify-content: space-between;
}



.references_reference_logo__Nt5Z0 {
    width: 184px;
    height: 102px; }`, "",{"version":3,"sources":["webpack://./src/components/References/references.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,SAAQ;IACR,uBAAuB;IACvB,yBAAyB;IACzB,8BAA8B;AAClC;;;;AAIA;IACI,YAAY;IACZ,aAAa,EAAE","sourcesContent":[".references_container{\r\n    display: flex; \r\n    flex-direction: row;\r\n    align-items: flex-start ; \r\n    flex: 1 ; \r\n    align-items: flex-start;\r\n    align-content: flex-start;\r\n    justify-content: space-between;\r\n}\r\n\r\n\r\n\r\n.reference_logo {\r\n    width: 184px;\r\n    height: 102px; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"references_container": `references_references_container__qXkI-`,
	"reference_logo": `references_reference_logo__Nt5Z0`
};
export default ___CSS_LOADER_EXPORT___;
